import { styleConstants } from '@paywithextend/components'
import { css, CSSProp, keyframes } from 'styled-components'

export const Processing = (): CSSProp => {
  const keyframe = keyframes`
    0% {
      transform:rotate(0deg);
    }
    100% {
      transform:rotate(360deg);
    }
  `
  return css`
    animation: ${keyframe} 1000ms infinite linear;
  `
}

export const AccentImageUp = (top: number): CSSProp => {
  const keyframe = keyframes`
    0% {
      top: ${top}px;
    }
    22% {
      top: ${top}px;
    }
    100% {
      top: -60px;
    }
  `
  return css`
    animation: ${keyframe} 800ms 1 ease-out;
  `
}

export const FlyoutFadeIn = (): CSSProp => {
  const keyframe = keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  `
  return css`
    animation: ${keyframe} ${styleConstants.transitionSpeed.slowest} 1;
  `
}

export const OcclusionFadeIn = (opacity?: number): CSSProp => {
  const keyframe = keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: ${opacity || 0.75};
    }
  `
  return css`
    animation: ${keyframe} ${styleConstants.transitionSpeed.slowest} 1;
  `
}

export const PopupFadeInAndExpand = (): CSSProp => {
  const keyframe = keyframes`
    0% {
      opacity: 0;
      transform: scale(0.97);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  `
  return css`
    animation: ${keyframe} ${styleConstants.transitionSpeed.slowest} 1;
  `
}

export const RightFlyoutSlideIn = (flyoutWidth: number): CSSProp => {
  const keyframe = keyframes`
    0% {
      right: -${flyoutWidth}px;
      opacity: 0;
    }
    100% {
      right: 0;
      opacity: 1;
    }
  `
  return css`
    animation: ${keyframe} ${styleConstants.transitionSpeed.slowest} 1;
  `
}

export const LeftFlyoutSlideIn = (
  flyoutWidth: number,
  endLeft: number,
): CSSProp => {
  const keyframe = keyframes`
    0% {
      left: ${-flyoutWidth + endLeft}px;
      opacity: 0;
    }
    100% {
      left: ${endLeft}px;
      opacity: 1;
    }
  `
  return css`
    animation: ${keyframe} ${styleConstants.transitionSpeed.slowest} 1;
  `
}

export const HideThenSlideLeft = (maxWidth: number): CSSProp => {
  const keyframe = keyframes`
    0% {
      opacity: 1;
      max-width: ${maxWidth}px;
    }
    99% {
      animation-timing-function: ease-out;
      opacity: 0;
      max-width: ${maxWidth}px;
    }
    100% {
      opacity: 0;
      max-width: 0;
    }
  `
  return css`
    animation: ${keyframe} ${styleConstants.transitionSpeed.slowest} 1;
  `
}

export const SlideRight = (start: number, end: number): CSSProp => {
  const keyframe = keyframes`
    0% {
      max-width: ${start}px;
    }
    100% {
      animation-timing-function: ease-out;
      max-width: ${end}px;
    }
  `
  return css`
    animation: ${keyframe} ${styleConstants.transitionSpeed.slowest} 1;
  `
}

export const SlideLeft = (start: number, end: number): CSSProp => {
  const keyframe = keyframes`
    0% {
      max-width: ${start}px;

    }
    100% {
      animation-timing-function: ease-out;
      max-width: ${end}px;
    }
  `
  return css`
    animation: ${keyframe} ${styleConstants.transitionSpeed.slowest} 1;
  `
}

export const ScaleAndFade = (): CSSProp => {
  const keyframe = keyframes`
    0% {
      transform: scale(0);
      opacity: 1;
    }
    100% {
      transform: scale(12);
      opacity: 0;
    }
  `
  return css`
    animation: ${keyframe} 500ms 1 linear;
  `
}

export const OpacityDimAndUp = (): CSSProp => {
  const keyframe = keyframes`
    0% {
      opacity: 1;
    }
    5%, 
    80% {
      animation-timing-function: ease-out;
      opacity: 0.5;
    }
    100% {
      animation-timing-function: ease-out;
      opacity: 1;
    }
  `
  return css`
    animation: ${keyframe} 1000ms 1;
  `
}

export const OpacityUpAndDownAndShiftRightAndLeft = (
  percent: number,
): CSSProp => {
  const keyframe = keyframes`
    0% {
      opacity: 0;
      left: 100%;
    }
    25%,
    80% {
      animation-timing-function: ease-out;
      opacity: 1;
      left: ${percent}%;
    }
    100% {
      animation-timing-function: ease-out;
      opacity: 0;
    }
  `
  return css`
    animation: ${keyframe} 1000ms 1;
  `
}

export const OpacityUpAndDownAndShiftLeftAndRight = (
  percent: number,
): CSSProp => {
  const keyframe = keyframes`
    0% {
      opacity: 0;
      right: 100%;
    }
    25%,
    80% {
      animation-timing-function: ease-out;
      opacity: 1;
      right: ${percent}%;
    }
    100% {
      animation-timing-function: ease-out;
      opacity: 0;
    }
  `
  return css`
    animation: ${keyframe} 1000ms 1;
  `
}

export const LeftToRight = (): CSSProp => {
  const keyframe = keyframes`
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 100% 0;
    }
  `
  return css`
    animation: ${keyframe} 1000ms linear alternate infinite;
  `
}

export const Blink = (): CSSProp => {
  const keyframe = keyframes`
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  `
  return css`
    animation: ${keyframe} 1000ms step-end infinite;
  `
}
